import React from "react";

const NotFound = () => {
  return <div className="home-card"></div>;
};

export default NotFound;
